import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import { Fade } from 'helpers/animation';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  cursorPointerMixin,
  paragraph500Mixin,
  textEllipsisFirstLineMixin,
} from 'styles';

const CustomResendViaPopup = ({
  isOpen,
  onClose,
  onResendViaEmail,
  onResendViaMobile,
  resendData,
}) => {
  return (
    <>
      <style>
        {`
        .custom-resend-via-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
          z-index: 1055;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={onClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="custom-resend-via-backdrop"
        centered
      >
        <ModalBody>
          <Item onClick={onResendViaMobile}>
            <p className="resend-item-title">{resendData?.[0]?.label}</p>
            <p className="resend-item-desc">{resendData?.[0]?.desc}</p>
          </Item>
          <Divider />
          <Item onClick={onResendViaEmail}>
            <p className="resend-item-title">{resendData?.[1]?.label}</p>
            <p className="resend-item-desc">{resendData?.[1]?.desc}</p>
          </Item>
        </ModalBody>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  ${Fade};
  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    & .modal-dialog {
      position: absolute;
      margin: 0;
      top: 0px;
      height: 100dvh;
      width: 100%;
      max-width: 100%;
      align-items: end;
      transition: ease-out 0.3s !important;
      transform: none;

      & .modal-content {
        padding: 0px;
        margin: 0;
        border-radius: 0px;
        box-shadow: none;
        background: var(--ds-c-white);
        width: 100%;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 20px 20px 0 0;
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      transform: none;
      & .modal-content {
        padding: 16px;
        border-radius: 12px;
        box-shadow: var(--ds-bs-4);
        background: var(--ds-c-white);
        width: 468px;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 8px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: left;
  margin: 0px;
  padding: 0px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 24px;
    padding-top: unset;
  }
`;

const Item = styled.div`
  ${cursorPointerMixin};
  height: 100px;
  padding-inline: 16px;
  display: grid;
  align-items: center;
  padding-block: 30px;

  & p {
    ${paragraph500Mixin};
    text-transform: uppercase;
    width: 100%;

    &.resend-item-title {
    }
    &.resend-item-desc {
      color: #7a8189;
      ${textEllipsisFirstLineMixin};
    }
  }
`;

const Divider = styled.div`
  border-top: 1px solid #ececf0;
  height: 1px;
  margin-inline: -16px;
`;

export default CustomResendViaPopup;
